import { stringify } from 'qs';
import { getAppyDetailInterface } from 'src/config/sceneEnum';
import { query, request } from 'src/utils/request';

// 差旅类型查询
export const reqExpenseType = async data => {
  return query('/zlb/api/expense/common/dic/get', {
    data,
    method: 'post',
  });
};

// 单位信息查询
export const reqCompanyInfo = async params => {
  return query('/zlb/api/expense/apply-form/default-info', {
    params,
  });
};

// 删除申请单
export const reqApplyDelete = async code => {
  return query(`/zlb/api/expense/apply-form/delete/${code}`, {
    method: 'POST',
  });
};

// 提交申请单
export const reqApplySubmit = async data => {
  return query('/zlb/api/expense/apply-form/submit', {
    method: 'POST',
    data,
  });
};

// 作废申请单
export const reqApplyNullify = async code => {
  return query(` /zlb/api/expense/apply-form/nullify/${code}`, {
    method: 'POST',
  });
};

// 查询申请单列表-页面废弃
export const reqApplyList = async data => {
  return query('/zlb/api/expense/apply-form/page', {
    method: 'POST',
    data,
  });
};

// 查询单个申请单
export const reqApplyDetail = async params => {
  return query(getAppyDetailInterface(params), {
    params,
  });
};

// 转交申请单
export const reqApplyForward = async data => {
  return query('/zlb/api/expense/apply-form/forward', {
    method: 'POST',
    data,
  });
};

// 转交百搭单据
export const reqBaidaForward = async data => {
  return query('/zlb/api/mbp/baida/business/general-form/forward', {
    method: 'POST',
    data,
  });
};

/** 获取区划树 */
export const reqSpecifiedLevelTree = params => {
  return query('/zlb/api/expense/address', {
    params,
  });
};

// 保存 & 创建 申请单
export const reqApplyCreateOrSave = data => {
  return query('/zlb/api/expense/apply-form/save', {
    method: 'POST',
    data,
  });
};

// 提交工作流
export const submitWorkFlow = data => {
  return request('/zlb/api/expense/workflow/submit', {
    method: 'POST',
    data,
  });
};

// 审核工作流
export const auditWorkFlow = data => {
  return request('/zlb/api/expense/workflow/audit', {
    method: 'POST',
    data,
  });
};

// 撤回工作流
export const stopWorkFlow = data => {
  return request('/zlb/api/expense/workflow/stop', {
    method: 'POST',
    data,
  });
};

// 生成会议和培训费用
export const generateFeeLimit = data => {
  return request('/zlb/api/expense/fee/record/genByMeetingOrTrain', {
    method: 'POST',
    data,
  });
};

// 根据费用代码获取修改费用信息
export const getModifyFeeRecords = async params => {
  return request('/zlb/api/expense/fee/expenseForm/getModifyFeeRecords', {
    params,
  });
};

// 修改调整费用信息
export const updateFeeAmount = async data => {
  return request('/zlb/api/expense/fee/updateFeeAmount', {
    method: 'POST',
    data,
  });
};

// 本单位下所有部门信息查询
export const reqAllCompanyInfo = async params => {
  return query('/api/zlbuser/institution/departs', {
    params,
  });
};

export const getCommodityList = async data => {
  return request('/zlb/api/expense/purchase/commodity/list', {
    method: 'POST',
    data,
  });
};

// 通用的四则运算
export async function calculator(params) {
  return query(`/zlb/api/sop/common/calculator?${stringify(params)}`);
}

// 加签
export function addTask(data) {
  return request('/zlb/api/expense/workflow/addTask', {
    method: 'POST',
    data,
  });
}

// 添加评论
export function submitComment(data) {
  return request('/zlb/api/expense/workflow/addComment', {
    method: 'POST',
    data,
  });
}

// 删除评论
export function delComment(data) {
  return request('/zlb/api/expense/workflow/deleteComment', {
    method: 'POST',
    data,
  });
}

// 查询采购目录层级
export const getPurchaseDirectory = async params => {
  return query(`/zlb/api/expense/purchase/manage/queryPurchaseDirectory?${stringify(params)}`);
};

// 查询资产品目
export const getPurchaseItem = async () => {
  return query('/zlb/api/expense/purchase/manage/queryPurchaseItem');
};

// 计算办公设备家具采购申请单限额
export const calculateFurnitureEequipment = async data => {
  return query('/zlb/api/expense/fee/expenseForm/calculateFurnitureEequipment', {
    method: 'POST',
    data,
  });
};

// 比较时间
export const compareTime = async params => {
  return query('/zlb/api/sop/common/compare-time', {
    params,
  });
};

// 获取申请来源
export const getDataSourceOptions = async () => {
  // return [
  //   {
  //     key: 0,
  //     value: '浙里报',
  //   },
  //   {
  //     key: 3,
  //     value: 'OA',
  //   }
  // ];
  return query('/zlb/api/expense/expense-form/getDocumentSourceEnum');
};

// 获取指定人员信息
export const getDesignateInfo = async data => {
  return request('/zlb/api/expense/meeting-sign/designated-list', {
    method: 'POST',
    data,
  });
};

// 指定人员信息
export const saveDesignated = async data => {
  return request('/zlb/api/expense/meeting-sign/designated', {
    method: 'POST',
    data,
  });
};

// 获取适配差旅接入政采云的其他信息的枚举数据
export const getAccessZCYEnumerate = async params => {
  return query('/zlb/api/expense/common/queryControlExtendView', {
    params,
  });
};

// 根据业务code获取百搭单据详情 业务数据详情
export const queryFormDefineByCode = async data => {
  return request('/magic/front/service/zcy.baida.queryFormDefine', {
    method: 'POST',
    data,
  });
};

// 招标书待办列表
export async function getApplyList(data) {
  data.businessType = 8;
  return query('/zlb/api/expense/apply-form/to-do-list', { method: 'POST', data });
}

export const getBaidaPrintContext = async params => {
  return query('/baida/print/get-context', {
    params,
  });
};

export const getBaidaPrintConfig = async params => {
  return query('/baida/print/get-config', {
    params,
  });
};

// 请假单查看详情
export const getLeaveDetail = async data => {
  return query('/zlb/api/office/leave/detail', {
    method: 'POST',
    data,
  });
};

// 计算请假时长
export const calLeaveDuration = async data => {
  return query('/zlb/api/office/leave/cal-duration', {
    method: 'POST',
    data,
  });
};

// 假期类型查询
export const getLeaveType = async () => {
  return query('/zlb/api/office/leave/type-query', {
    method: 'POST',
  });
};

// 请假单提交
export const submitLeave = async data => {
  return query('/zlb/api/office/leave/submit', {
    method: 'POST',
    data,
  });
};

// 请假单作废
export const cancelLeave = async data => {
  return query('/zlb/api/office/leave/cancel', {
    method: 'POST',
    data,
  });
};

// 保存租车单
export const saveRental = async data => {
  return query('/zlb/api/expense/apply-rental/form-save', {
    method: 'POST',
    data,
  });
};

// 提交租车单
export const submitRental = async data => {
  return query('/zlb/api/expense/apply-rental/form-submit', {
    method: 'POST',
    data,
  });
};

// 租车单详情
export const getRentalDetail = async data => {
  return query('/zlb/api/expense/apply-rental/form-detail', {
    data,
    method: 'POST',
  });
};

// 租车单删除
export const deleteRental = async data => {
  return query('/zlb/api/expense/apply-rental/form-delete', {
    method: 'POST',
    data,
  });
};

// 租车单作废
export const cancelRental = async data => {
  return query('/zlb/api/expense/apply-rental/form-cancel', {
    method: 'POST',
    data,
  });
};

// 获取加班单初始化数据
export const initOvertime = async data => {
  return query('/zlb/api/expense/overtime/init', {
    method: 'POST',
    data,
  });
};

// 计算加班时长
export const overtimeCalculateHours = async data => {
  return query('/zlb/api/expense/overtime/calculate-hours', {
    method: 'POST',
    data,
  });
};
// 手机格式化校验
export const checkPhoneMat = async params => {
  return query(`/zlb/api/expense/common/phone-format/check?${stringify(params)}`);
};
// 租车信息初始化
export const initRentalInfo = async data => {
  return query('/zlb/api/expense/apply-rental/rental-info/init', {
    method: 'POST',
    data,
  });
};

// 差旅其他信息， 查询项目信息（部门-项目）
export const queryEpProject = async data => {
  return query('/zlb/budget/ep/project/query', {
    method: 'POST',
    data,
  });
};

// 获取上一单通用信息 formType formScenes
export const getLastCommonInfo = async data => {
  return query('/zlb/api/expense/form/last-form/common-info', {
    method: 'POST',
    data,
  });
};

// 申请单变更
export const changeApply = async data => {
  return query('/zlb/api/expense/apply-form/change', {
    method: 'POST',
    data,
  });
};
//获取台州特检院采购申请单科研内容物类型下经费支出类型
export const getTypeOfExpenditure = async data => {
  return query('/zlb/api/expense/common/dic/get', {
    method: 'POST',
    data,
  });
};

// 获取台州特检院采购内容变更历史
export const reqPurchaseContentHistory = async params => {
  return query('/zlb/api/expense/purchase/manage/purchaseContentHistory', {
    params,
    method: 'GET',
  });
};

// 获取商机线索接口
export const getCluList = async data => {
  return query('/zlb/api/sop/lead/lead-list', {
    data,
    method: 'POST',
  });
};

// 检查是否是工作日
export const checkIsWorkDay = async data => {
  return query('/zlb/api/expense/common/is-holiday', {
    method: 'POST',
    data,
  });
};
